import { Directive, HostBinding, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CommonStylesForRender } from 'render/render.models';
import { RenderSeoService } from 'render/services/render-seo.service';
import { UnsubscribeComponent } from 'shared/directives/unsubscribe.component';
import { IdtComponent } from 'shared/models/idt-components/idt-component.models';
import { MetaTag } from 'shared/models/meta-tags.models';


interface BaseLayout {
  general: Record<string, unknown>;
  styles: CommonStylesForRender;
}

@Directive()
export abstract class LayoutBaseRenderComponent<T extends BaseLayout>
  extends UnsubscribeComponent
  implements OnInit {

  @Input() public layout: IdtComponent<T> | undefined;
  @HostBinding('style.background-color') public backgroundColor: string | undefined;

  constructor(
    protected readonly route: ActivatedRoute,
    protected readonly seoService: RenderSeoService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.backgroundColor = this.layout?.settings?.styles?.bgColor;
    this.setTitleAndMetaTags();
    this.onInitHook();
  }

  protected onInitHook(): void { /* empty */ }

  private setTitleAndMetaTags(): void {
    combineLatest([this.route.paramMap, this.route.queryParams]).pipe(
      takeUntil(this.clearSubscriptions$)
    ).subscribe(([paramMap,]) => {
      const title = this.layout?.settings?.general?.title as string ?? '';
      this.seoService.setPageTitle(title);
      this.seoService.setPageMetas(this.layout?.settings?.general?.metaTags as MetaTag[] ?? []);

      if (paramMap !== null && !paramMap.get('productId') && !paramMap.get('categoryId')) {
        this.seoService.addPageTitle();
        this.seoService.addPageMetas();
      }
    });
  }

}
